<div class="wrapper">
    <div *ngIf="!loading" class="body">
        <img class="logo" src="../../../assets/img/logoitsi.png" alt="img login">
        <h3 class="mb-2">Login</h3>

        <div class="form-floating mb-3 mt-3">
            <input type="text" [(ngModel)]="username" (keydown)="handleKeydown($event)" autocomplete="false" class="form-control" placeholder="Ingrese usuario">
            <label>Usuario</label>
        </div>

        <div class="form-floating mb-3">
            <input type="password" [(ngModel)]="password" (keydown)="handleKeydown($event)" autocomplete="false" class="form-control" placeholder="Ingrese password">
            <label>Password</label>
        </div>

        <div class="d-grid gap-2">
            <button type="button" class="btn btn-primary btn-lg" (click)="login()">Aceptar</button>
        </div>
        <!--<p class="mt-3">¿Olvidaste la contraseña? <a routerLink="/forgot">Restaurar</a></p>-->
    </div>
    <app-spinner *ngIf="loading"></app-spinner>
</div>
